import { Icon } from '@iconify/react'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import JSONPretty from 'react-json-pretty'

type Props = {
  data: any
}

const JSONAccordion = ({ data }: Props) => {
  return (
    <Accordion
      sx={{
        marginBlock: '2rem'
      }}
    >
      <AccordionSummary expandIcon={<Icon icon="icon-park-outline:down" />}>Floors JSON</AccordionSummary>
      <AccordionDetails>
        <JSONPretty data={data} />
      </AccordionDetails>
    </Accordion>
  )
}

export default JSONAccordion